import React from 'react';
import { Modal } from 'antd';
import { connect } from 'react-redux';
import hostedTablesActions from 'redux/hostedTables/actions';
import UploadHostedCSV from './UploadHostedCSV';
import HostedColumns from './HostedColumns';
import HostedTablePreview from './HostedTablePreview';
import { HOSTED_TABLE_TABS } from './HostedLookupTablesList';

const UploadHostedLookupTable = ({ step, isVisible, setUploadPopupVisible, setHostedTablsData, maxColumnsCount, maxRowsCount, showPreview, setStep, activeTab, tableInfo = {}, isEdit }) => {

  const handleCancel = () => {
    setHostedTablsData({ step: 1, tableName: '', file: null, containsHeader: true, numberOfColumn: 1, uploadData: true, delimiter: ',', isEdit: false });
    setUploadPopupVisible(false);
  };

  return (
    <>
      <Modal
        className="rc-upload-hosted-lookup-table-popup"
        visible={isVisible}
        title={activeTab === HOSTED_TABLE_TABS.TABLES ? "Upload Hosted Lookup Table" : 'Upload Conversational Table'}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        activeTab={activeTab}
        width={800}
      >
        {
          step === 1 &&
          <UploadHostedCSV
            maxColumnsCount={maxColumnsCount}
            maxRowsCount={maxRowsCount}
            cancelForm={handleCancel}
            setHostedTablsData={setHostedTablsData}
            showPreview={showPreview}
            activeTab={activeTab}
            // tableInfo={tableInfo}
            isEdit={isEdit}
          />
        }
        {step === 2 && <HostedColumns cancelForm={handleCancel} activeTab={activeTab} isEdit={isEdit} />}
        {step === 3 && <HostedTablePreview setStep={setStep} cancelForm={handleCancel} activeTab={activeTab} />}
      </Modal>
    </>
  );
};


const mapStatetoProps = (state) => ({
  step: state.hostedTables.step,
  maxColumnsCount: state.hostedTables.maxColumnsCount,
  maxRowsCount: state.hostedTables.maxRowsCount,
  isEdit: state.hostedTables.isEdit
});

const mapDispathTopProps = (dispatch) => ({
  setHostedTablsData: (data) => dispatch(hostedTablesActions.setHostedTablsData(data)),
  setUploadPopupVisible: (uploadPopupVisible) => dispatch(hostedTablesActions.setUploadPopupVisible(uploadPopupVisible)),
  showPreview: (file, delimiter, containsHeader, tableName) => dispatch(hostedTablesActions.showPreview(file, delimiter, containsHeader, tableName)),
  setStep: (step) => dispatch(hostedTablesActions.setStep(step)),
});

export default connect(mapStatetoProps, mapDispathTopProps)(UploadHostedLookupTable);
